export default __webpack_public_path__ + "static/media/call_history.2470e6af.png";